import { Box, Button, TextField, Typography, Stack, Snackbar, Alert } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { useEffect, useState, SyntheticEvent } from 'react';
import './RegistrationPage.scss';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { regUserI } from '../../interfaces/user';
import { registrationUser } from '../../services/registration';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { errorHandler } from '../../services/errorHandler';

const RegistrationPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showSnack, setShowSnack] = useState(false);
  const { responseCode } = useAppSelector((state) => state.user);
  const errorText = errorHandler(responseCode);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isValid },
  } = useForm<regUserI>({ mode: 'onBlur', reValidateMode: 'onChange' });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnack(false);
  };

  const onSubmit: SubmitHandler<regUserI> = (data: regUserI) => {
    dispatch(registrationUser(data));
    console.log(data);
    reset();
  };

  useEffect(() => {
    if (responseCode) {
      setShowSnack(true);
    }
  }, [responseCode]);

  const requiredValidation = { required: 'Это обязательное поле' };

  return (
    <Box component="form" className="form" onSubmit={handleSubmit(onSubmit)}>
      <div className="form-wrapper">
        <Typography variant="h6" component="h6" margin="normal" sx={{ m: 4 }}>
          Регистрация нового пользователя
        </Typography>
        <Controller
          control={control}
          name="login"
          defaultValue=""
          render={({ field }) => (
            <TextField
              sx={{ m: 2 }}
              fullWidth
              id="registrationLogin"
              label="Логин"
              {...register('login', requiredValidation)}
              value={field.value}
              onChange={(e) => field.onChange(e)}
              variant="outlined"
              helperText={errors?.login?.message}
              error={!!errors?.login}
            />
          )}
        />
        <Controller
          control={control}
          name="name"
          defaultValue=""
          render={({ field }) => (
            <TextField
              sx={{ m: 2 }}
              fullWidth
              id="registrationName"
              label="Имя пользователя"
              {...register('name', requiredValidation)}
              value={field.value}
              onChange={(e) => field.onChange(e)}
              variant="outlined"
              helperText={errors?.name?.message}
              error={!!errors?.name}
            />
          )}
        />
        <Controller
          control={control}
          name="type"
          render={({ field }) => (
            <TextField
              defaultValue=""
              fullWidth
              sx={{ m: 1 }}
              variant="outlined"
              id="registrationRole"
              select
              label="Роль"
              SelectProps={{
                native: true,
              }}
              helperText={errors?.type?.message}
              {...register('type', requiredValidation)}
              value={field.value}
              onChange={(e) => field.onChange(e)}
              error={!!errors?.type}
            >
              {/*<option value=""></option>*/}
              <option value="2">Администратор поддержки</option>
              <option value="3">Администратор службы</option>

              {/*<optgroup*/}
              {/*  label="Администратор службы"*/}
              {/*  onChange={(e) => {*/}
              {/*    console.log(e.target);*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <option value="служба1">Служба 1</option>*/}
              {/*  <option value="служба1"> Служба 2</option>*/}
              {/*  <option value="служба1"> Служба 3</option>*/}
              {/*</optgroup>*/}
            </TextField>
          )}
        />
        <Controller
          control={control}
          name={'password'}
          defaultValue=""
          render={({ field }) => (
            <TextField
              sx={{ m: 2 }}
              fullWidth
              id="registrationPass"
              label="Пароль"
              {...register('password', requiredValidation)}
              type={showPassword ? 'text' : 'password'}
              value={field.value}
              onChange={(e) => field.onChange(e)}
              helperText={errors?.password?.message}
              error={!!errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
          )}
        />
        <Button variant="contained" type={'submit'} sx={{ m: 2, paddingX: 5 }}>
          Зарегистрировать
        </Button>
      </div>
      <Stack>
        <Snackbar open={showSnack} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            {errorText}
          </Alert>
        </Snackbar>
      </Stack>
    </Box>
  );
};
export default RegistrationPage;
